'use client';
import { FC } from 'react';
import { OWCategoryPage } from '../../interfaces/domain/ow-category-page.modal';
import CategoryHeader from '../layout/category-header/category-header';
import { CarouselImageSlider } from '../carousel-image-slider/carousel-image-slider';
import Shelve from '../shelve/shelve';
import { DownloadModalWrapper } from '../download-modal/download-modal-wrapper';
import { CategoryPageTracking } from '../tracking/category-page-tracking/category-page-tracking';
import { BreadCrumbs } from '../breadcumbs/breadcrumbs';

interface CategoryContainerProps {
  categoryData: OWCategoryPage;
}

// -----------------------------------------------------------------------------
export const CategoryContainer: FC<CategoryContainerProps> = (props) => {
  const { pageTitle, layoutClassName, carousel, shelves } = props.categoryData;

  return (
    <div className={layoutClassName}>
      <DownloadModalWrapper />
      <CategoryPageTracking />

      {carousel && <CarouselImageSlider sliderData={carousel} />}
      <BreadCrumbs />
      {pageTitle && <CategoryHeader title={pageTitle} />}

      {shelves.map((shelve, index) => {
        return <Shelve key={index} shelveData={shelve} />;
      })}
    </div>
  );
};
